
	import { ref, defineComponent, computed, watch, reactive, toRaw, onMounted } from 'vue'
	import { useStore } from 'vuex'
	import { mod, add } from '../request'
	import { message } from 'ant-design-vue'
	import { statusOptions, appPkgOptions } from '../config'
	import BusinessFilter from '@/common/components/BusinessFilter.vue'
	import ossUpload from '@/common/functions/ossUpload'
	import { systemList, packageDetail } from '../request'
	import { systemMenu } from '@/modules/menu/request'
	import { menuDetail } from '@/modules/version/request'
	import MenuList from '@/modules/menu/components/MenuList.vue'

	export default defineComponent({
		components: {
			BusinessFilter,
			MenuList
		},
		setup(props, { emit }) {
			const store = useStore()
			const formRef = ref()
			let menus = ref([])
			let systemOptions = ref([])
			const detail = computed(() => store.state.packages.detail)
			interface Form {
				[key: string]: any
			}
			const form = reactive<Form>({
				remark: '',
				systemId: null,
				isAppPkg: 0,
				menuCodes: [],
				packageName: ''
			})
			const init = () => {
				let detailValue = detail.value
				if (detailValue) {
					Object.assign(form, {
						packageName: detailValue.name,
						remark: detailValue.remark
					})
				}
			}
			const rules = {
				systemId: [
					{
						required: true,
						message: '请选择系统',
						type: 'number'
					}
				],
				packageName: [
					{
						required: true,
						message: '请输入功能集名称'
					}
				],
				isAppPkg: [
					{
						required: true,
						message: '请选择是否是功能包',
						type: 'number'
					}
				]
			}
			/**
			 * 获取所有选中的子模块
			 */
			const getSelectMenuCodes = (): Array<string> => {
				let menuCodes: Array<string> = []
				function getModuleId(node: any) {
					if (node.checked) {
						menuCodes.push(node.code)
					}
					if (node.children && node.children.length) {
						node.children.forEach((item: any) => {
							getModuleId(item)
						})
					}
				}
				menus.value.forEach((module: any) => {
					getModuleId(module)
				})
				return menuCodes
			}
			const loading = ref<boolean>(false)
			const afterClose = () => {
				store.commit('togglePackageAddState', false)
				store.commit('setPackageDetail', null)
			}
			const onSubmit = () => {
				formRef.value.validate().then(async () => {
					let formValue = toRaw(form)
					let params = {
						...form,
						menuCodes: getSelectMenuCodes()
					}
					let request = detail.value ? mod : add
					if (detail.value) {
						Object.assign(params, {
							packageId: detail.value.id
						})
					}
					loading.value = true
					try {
						await request(params)
						emit('success')
						message.success('保存成功')
						afterClose()
						loading.value = false
					} catch (e) {
						loading.value = false
					}
				})
			}
			function handleChange(info) {
				if (info.file.status === 'uploading') {
					loading.value = true
					return
				}
			}
			function removeAttachment(index) {
				form.attachments.splice(index, 1)
			}
			function changeBusinsess(event) {
				form.corpName = event.name
			}
			function fetchSystemList() {
				systemList().then((res) => {
					systemOptions.value = res.data
				})
			}
			async function customUploadRequest(param) {
				let res: any = await ossUpload(param)
				let data = res.data
				loading.value = false
				form.attachments.push(data.url)
			}
			/**
			 * 获取菜单树
			 */
			const fetchMenuTree = async () => {
				let res = await systemMenu({})
				menus.value = res.data
			}
			const fetchDetail = async () => {
				let res = await packageDetail({
					packageId: detail.value.id
				})
				let data = res.data
				form.systemId = data.systemId
				form.isAppPkg = data.isAppPkg || 0
				let codes = data.menuCodes
				fillModuleCodes(codes)
			}
			// 回填module ids
			const fillModuleCodes = (codes: Array<string>) => {
				function setChecked(node: any) {
					if (codes.indexOf(node.code) > -1) {
						node.checked = true
					}
					if (node.children && node.children.length) {
						node.children.forEach((item: any) => {
							setChecked(item)
							// 子节点选中，就把父节点展开
							if (codes.indexOf(item.code) > -1) {
								node.expand = true
							}
						})
					}
				}
				menus.value.forEach((module: any) => {
					setChecked(module)
				})
			}
			watch(detail, () => {
				init()
			})
			onMounted(async () => {
				loading.value = true
				try {
					await fetchMenuTree()
					if (detail.value?.id) {
						await fetchDetail()
					}
				} catch (e) {
					loading.value = false
					console.log(e)
				}
				loading.value = false
				fetchSystemList()
			})
			init()
			return {
				form,
				store,
				loading,
				rules,
				onSubmit,
				afterClose,
				statusOptions,
				detail,
				formRef,
				handleChange,
				removeAttachment,
				changeBusinsess,
				customUploadRequest,
				menus,
				systemOptions,
				appPkgOptions
			}
		}
	})
